import { render, staticRenderFns } from "./OfficerTrainingSchoolClassModalComponent.vue?vue&type=template&id=4ba0dab4&"
import script from "./OfficerTrainingSchoolClassModalComponent.vue?vue&type=script&lang=ts&"
export * from "./OfficerTrainingSchoolClassModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba0dab4')) {
      api.createRecord('4ba0dab4', component.options)
    } else {
      api.reload('4ba0dab4', component.options)
    }
    module.hot.accept("./OfficerTrainingSchoolClassModalComponent.vue?vue&type=template&id=4ba0dab4&", function () {
      api.rerender('4ba0dab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/OfficerTrainingSchoolClass/OfficerTrainingSchoolClassModalComponent.vue"
export default component.exports